//@ts-check
import { Button, Flex, Heading, Link as SpectrumLink, Text } from '@adobe/react-spectrum';
import React, { useContext } from 'react';

import { RegionList } from '@exchange-frontends/components';
import { usePublisherLink } from '@exchange-frontends/custom-hooks';

import Region from '../../../../../components/Region';
import { EllipsisText } from '../../../../../components/styled-components/EllipsisText';
import { useStore } from '../../../store';
import { AppDetailsContext } from '../AppDetails';

const SlnSidebarPublisher = () => {
  /** @type {import('@action-types/ecApp').AppDetails} */
  const detailScreen = useStore((state) => state.detailScreen || {});
  const { cloud } = useContext(AppDetailsContext);
  const { publisher, solutionDetails, appType } = detailScreen;
  const { solutionSupportDetails } = solutionDetails?.internalFields || {};
  const { website } = publisher || {};
  const { openPublisherLink } = usePublisherLink({ publisher, appType, cloud });

  return (
    <>
      {website && (
        <EllipsisText>
          <SpectrumLink aria-label="Partner website" href={website} target="_blank" rel="noopener noreferrer">
            {website}
          </SpectrumLink>
        </EllipsisText>
      )}
      <Button maxWidth="152px" alignSelf="center" variant="primary" onPress={openPublisherLink}>
        View partner details
      </Button>

      {(solutionSupportDetails?.solutionKeyContactEmail || solutionSupportDetails?.email) && (
        <Flex direction="column">
          <Heading marginTop={0} marginBottom="size-50" level={4}>
            Contact person
          </Heading>
          <Flex direction="column" gap="size-50">
            {solutionSupportDetails.differentContactPerson ? (
              <>
                <Text>{solutionSupportDetails.solutionKeyContactName}</Text>
                <Text>{solutionSupportDetails.solutionKeyContactTitle}</Text>
                <Text>{solutionSupportDetails.solutionKeyContactEmail}</Text>
              </>
            ) : (
              <>
                <Text>{solutionSupportDetails.partnerContactName}</Text>
                <Text>{solutionSupportDetails.title}</Text>
                <Text>{solutionSupportDetails.email}</Text>
              </>
            )}
          </Flex>
        </Flex>
      )}
      {solutionSupportDetails?.partnerRegion && (
        <Flex direction="column">
          <Heading marginTop={0} marginBottom="size-50" level={4}>
            Region
          </Heading>
          <Region>{solutionSupportDetails.partnerRegion}</Region>
        </Flex>
      )}
    </>
  );
};

export default SlnSidebarPublisher;
